import { sendVersicherungsfall } from "@/api/schadensmeldung";
import { isLoggedIn } from "../api/auth";
import { handleError } from "../utils/error";
import store from "@/store";

export const schadensmeldung = {
    props: {
        contractId: {
            type: String,
            required: false,
            default: "",
        },
        motive: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            isFormSubmitted: false,
        };
    },
    watch: {
        contractIdForCard(val) {
            if (val !== "") {
                this.setFormData();
            }
        },
    },
    mounted() {
        store.commit("setLoading", true);
        isLoggedIn()
            .then(() => {
                if (this.contractIdForCard !== "") {
                    this.setFormData();
                }
                // store.commit("setLoading", true);
                this.$store.cache.dispatch("user/getUserAddress").then(() => {
                    let userdetails = this.$store.state.user.details;
                    if (Object.keys(userdetails).length > 0) {
                        this.formData.email = userdetails.email;
                        this.formData.geschlecht = userdetails.geschlecht;
                        this.formData.hausnr = userdetails.hausnummer;
                        this.formData.zuname = userdetails.nachname;
                        this.formData.ort = userdetails.ort;
                        this.formData.plz = userdetails.plz;
                        this.formData.strasse = userdetails.strasse;
                        this.formData.telefon = userdetails.telefon;
                        this.formData.titel = userdetails.titel;
                        this.formData.vorname = userdetails.vorname;
                        if (
                            userdetails.geburtstag !== undefined &&
                            userdetails.geburtstag !== ""
                        ) {
                            let geburtsdatum = userdetails.geburtstag.split(
                                "."
                            );
                            this.formData.geburtsdatum =
                                geburtsdatum[2] +
                                "-" +
                                geburtsdatum[1] +
                                "-" +
                                geburtsdatum[0];
                        }
                    }
                });
            })
            .catch((error) => {
                handleError(error);
                // if (this.formData.mode === "kfz") {
                //     this.$ionic.alertController
                //         .create({
                //             header: "MO'Drive",
                //             message:
                //                 "Wenn du die Vorteile von MO'Drive* nützen willst, solltest du deine Schadensmeldung im eingeloggten Bereich vornehmen. <br>*(möglich nur mit Voll- oder Teilkasko)",
                //             buttons: [
                //                 {
                //                     text: "Nein danke",
                //                     role: "cancel",
                //                 },
                //                 {
                //                     text: "Zum Login",
                //                     handler: () => {
                //                         this.$router.push({ name: "login" });
                //                     },
                //                 },
                //             ],
                //         })
                //         .then((a) => {
                //             a.present();
                //         });
                // }
            });

        // this.$store
        //     .dispatch(
        //         "contractsDetails/getContractDetails",
        //         this.contractId
        //     )
        //     .then(() => {
        //         let contractdetails = this.$store.state.contractsDetails
        //             .all;
        //         if (Object.keys(contractdetails).length > 0) {
        //             this.formData.kennzeichennummer =
        //                 contractdetails.kennzeichennummer;
        //         }
        //     });
    },
    beforeRouteLeave(to, from, next) {
        if (to.path !== "/aktion") {
            if (!this.isFormSubmitted && to.name !== "login") {
                this.$ionic.alertController
                    .create({
                        header: "Seite verlassen?",
                        message:
                            "Möchtest du die aktuelle Seite wirklich verlassen? Die Formulardaten werden nicht gespeichert.",
                        buttons: [
                            {
                                text: "Nein",
                                role: "cancel",
                                handler: () => {
                                    next(false);
                                },
                            },
                            {
                                text: "Ja",
                                handler: () => {
                                    next();
                                },
                            },
                        ],
                    })
                    .then((a) => a.present());
            } else {
                next();
            }
        }
    },
    computed: {
        shouldPresentContractSwitcherModal() {
            let result = false;
            if (
                this.contractId === "" &&
                this.$store.getters.schadensmeldungen[this.feature] &&
                this.$store.getters.schadensmeldungen[this.feature].length > 1
            ) {
                result = true;
            }
            return result;
        },
        contractIdForCard() {
            let result = "";
            if (this.contractId !== "") {
                result = this.contractId;
            } else if (
                this.$store.getters.schadensmeldungen[this.feature] &&
                this.$store.getters.schadensmeldungen[this.feature].length > 0
            ) {
                result = this.$store.getters.schadensmeldungen[this.feature][0];
            }
            return result;
        },
        contractDetails() {
            let result = {};
            if (
                this.contractIdForCard in this.$store.state.contractsDetails.all
            ) {
                result = this.$store.state.contractsDetails.all[
                    this.contractIdForCard
                ];
            }
            return result;
        },
    },
    methods: {
        setFormData() {
            if (this.formData.mode === "kfz") {
                // this.$store.commit("setLoading", true);
                this.$store.cache
                    .dispatch(
                        "contractsDetails/getContractDetails",
                        this.contractIdForCard
                    )
                    .then(() => {
                        if ("KfzKennzeichen" in this.contractDetails) {
                            this.formData.kennzeichennummer = this.contractDetails.KfzKennzeichen;
                            this.isKennzeichennummerDisabled = true;
                        }
                        if ("KfzBezeichnung" in this.contractDetails) {
                            this.formData.kfzmarke = this.contractDetails.KfzBezeichnung;
                            this.isKfzmarkeDisabled = true;
                        }
                        if (
                            "MoDrivePossible" in this.contractDetails &&
                            this.contractDetails.MoDrivePossible
                        ) {
                            this.formData.isModrivePossible = true;
                            this.formData.kfzart = "PKW";
                            this.isKfzartDisabled = true;
                        }
                    });
            }
            if (this.formData.polizzenversicherung !== undefined) {
                this.formData.polizzenversicherung = this.contractIdForCard;
            }
        },
        fillPlaceData() {
            this.formData.unfallStrasse = this.formData.strasse;
            this.formData.unfallHausnr = this.formData.hausnr;
            this.formData.unfallStiege = this.formData.stiege;
            this.formData.unfallStock = this.formData.stock;
            this.formData.unfallTuer = this.formData.tuer;
            this.formData.unfallPlz = this.formData.plz;
            this.formData.unfallOrt = this.formData.ort;
        },
        submitForm() {
            if (this.formData.formstep === this.stepCount) {
                this.$ionic.alertController
                    .create({
                        header: "Schadensmeldung übermitteln",
                        message:
                            "Möchtest du die Schadensmeldung jetzt an Wüstenrot übermitteln?",
                        buttons: [
                            {
                                text: "Nein",
                                role: "cancel",
                            },
                            {
                                text: "Ja",
                                handler: () => {
                                    this.sendVersicherungsfall();
                                },
                            },
                        ],
                    })
                    .then((a) => a.present());
            } else {
                this.sendVersicherungsfall();
            }
        },
        sendVersicherungsfall() {
            this.$store.commit("setLoading", true);
            sendVersicherungsfall(this.formData).then((response) => {
                this.$refs.page.scrollToTop();
                if (response.data.Status === 200) {
                    if (response.data.Result.MessageSent === true) {
                        this.isFormSubmitted = true;
                        let modriveText = "";
                        if (
                            this.formData.modrive &&
                            this.formData.modrive === "Ja" &&
                            this.formData.modriveVersicherungsart !==
                                "Nur Haftpflicht"
                        ) {
                            modriveText =
                                " und du wirst umgehend von MO'Drive kontaktiert";
                        }
                        this.$ionic.alertController
                            .create({
                                header: "Schadensmeldung erfolgreich",
                                message:
                                    "Deine Schadensmeldung wurde erfolgreich an Wüstenrot übermittelt" +
                                    modriveText +
                                    ".",
                                buttons: ["Ok"],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$router.push({
                                        name: "schadensmeldung",
                                    });
                                    this.$store.commit("setAskForRating", true);
                                });
                                a.present();
                            });
                    } else {
                        this.formData.formstep++;
                    }
                }
            });
        },
        stepBack() {
            this.$refs.page.scrollToTop();
            this.formData.formstep--;
        },
    },
};
